import React from "react";
import "./instruction.scss";
const Instruction = () => {
    return (
        <div className="page-content__container">
            <div className="instruction">instruction content</div>
        </div>
    );
};

export default Instruction;
